const countrySelect =
  document.querySelector<HTMLSelectElement>('[name=country]');
const resolutionSelect =
  document.querySelector<HTMLSelectElement>('[name=resolution]');
const subdivisionOptionName = 'Exact ISO subdivision';
const exactCityOption = document.querySelector<HTMLOptionElement>(
  '[name="Exact city"]',
);

const addRemoveSubdivisionOption = () => {
  const subdivOption = resolutionSelect?.namedItem(subdivisionOptionName);
  if (countrySelect?.value === 'US') {
    // We want to add the subdivision option if it isn't already there.
    if (!subdivOption) {
      const newOption = new Option(subdivisionOptionName, 'subdivision');
      newOption.setAttribute('name', subdivisionOptionName);
      resolutionSelect?.add(newOption, exactCityOption);
    }
  } else {
    // We want to remove the subdivision option if it is there.
    if (subdivOption) resolutionSelect?.remove(subdivOption.index);
  }
};

countrySelect?.addEventListener('change', () => {
  addRemoveSubdivisionOption();
});

addRemoveSubdivisionOption();

document.querySelectorAll('.js-accuracy-width').forEach((el) => {
  const percent = parseFloat(el.getAttribute('data-percent') || '0');
  if (percent && Math.floor(percent * 100)) {
    el.classList.add(
      `accuracy-comparison__graph-bar--width-${Math.ceil(percent * 100)}`,
    );
  } else {
    el.classList.add('d-none');
  }
  el.classList.remove('invisible');
});
